import React from 'react';
import Badge from '@tencent/dui/lib/components/Badge';
import { ErrorBoundary } from '../../utils/error-boundary.js';

const MenuContent = ({ item, badge }) => {
    const { content } = item;
    let element;
    if (typeof content === 'function') {
        element = content();
    }
    else {
        element = content;
    }
    if (React.isValidElement(element)) {
        if (typeof element.type === 'string') {
            // instanceof HTMLElement
            element = React.cloneElement(element, {
                onMouseDown: (e) => { e.preventDefault(); },
            });
        }
    }
    if (badge) {
        return React.createElement(ErrorBoundary, null,
            React.createElement("div", { style: { position: 'relative' } }, element !== null && element !== void 0 ? element : null,
                React.createElement(Badge, { status: "error", style: { position: 'absolute', top: '50%', transform: 'scale(0.6) translateY(-80%)' } })));
    }
    return React.createElement(ErrorBoundary, null, element !== null && element !== void 0 ? element : null);
};

export { MenuContent };
//# sourceMappingURL=menu-content.js.map
